module.exports = __webpack_public_path__ + "img/logo-federlegno.2752ece8.jpg";